<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item>
          <a-range-picker
            :defaultValue="[
              moment()
                .day(moment().day() - 30)
                .startOf('day'),
              moment()
            ]"
            :ranges="{
              昨天: [
                moment()
                  .day(moment().day() - 1)
                  .startOf('day'),
                moment()
                  .day(moment().day() - 1)
                  .endOf('day')
              ],
              上周: [
                moment()
                  .week(moment().week() - 1)
                  .startOf('week'),
                moment()
                  .week(moment().week() - 1)
                  .endOf('week')
              ],
              上个月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
              ],
              上个季度: [
                moment()
                  .quarter(moment().quarter() - 1)
                  .startOf('quarter'),
                moment()
                  .quarter(moment().quarter() - 1)
                  .endOf('quarter')
              ]
            }"
            :disabledDate="disabledDate"
            :value="dateTimeRange"
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            @change="onChangeDatePicker"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            :value="selectDepartment"
            @change="handleDepartment"
            style="width:150px"
          >
            <a-select-option value="">全部部门</a-select-option>
            <a-select-option
              v-for="item in departmentList"
              :key="item.id"
              :value="item.id"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-select :value="consumeType" @change="changeConsumeType">
            <a-select-option value="">全部支付方式</a-select-option>
            <a-select-option value="1">点餐支付</a-select-option>
            <a-select-option value="2">刷卡支付</a-select-option>
            <a-select-option value="4">扫码枪扣费</a-select-option>
            <a-select-option value="3">睿吃扫码扣费</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-select :value="cardType" @change="changeCardType">
            <a-select-option value="">全部类型卡</a-select-option>
            <a-select-option
              v-for="item in cardTypeList"
              :key="item.id"
              :value="item.id"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" style="margin-left: 10px;" @click="search">
            <a-icon type="search" />
            查询
          </a-button>
          &emsp;
        </a-form-item>
        <a-button
          type="primary"
          style="float:right;margin-top:4px;"
          @click="download"
        >
          <a-icon type="cloud-download" />
          导出报表
        </a-button>
      </a-form>
    </div>
    <!-- 表格 -->
    <a-table
      :columns="tableColumns"
      :dataSource="tableData"
      bordered
      :pagination="pagination"
      :loading="tableLoading"
      size="small"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: getCheckboxProps
      }"
    />
  </div>
</template>
<script>
import moment from 'moment';
import { GetCardTypeList } from '@/apis/card'
import { GetConsumeReportByDate, DownloadConsumeReportByDateExcel } from '@/apis/report';
import { GetDepartmentDropdownList } from '@/apis/department'
import { getDateTimeRange } from '@/utils/base'

const tableColumns = [
  {
    title: '日期',
    dataIndex: 'date',
    key: 'date',
    align: 'center'
  },
  {
    title: '早餐',
    children: [
      {
        title: '金额',
        dataIndex: 'breakfastMoney',
        key: 'breakfastMoney',
        align: 'center'
      },
      {
        title: '次数',
        dataIndex: 'breakfastCount',
        key: 'breakfastCount',
        align: 'center'
      }
    ]
  },
  {
    title: '午餐（定额+超额）',
    children: [
      {
        title: '金额',
        dataIndex: 'lunchMoney',
        key: 'lunchMoney',
        align: 'center'
      },
      {
        title: '次数',
        dataIndex: 'lunchCount',
        key: 'lunchCount',
        align: 'center'
      }
    ]
  },
  {
    title: '晚餐',
    children: [
      {
        title: '金额',
        dataIndex: 'dinnerMoney',
        key: 'dinnerMoney',
        align: 'center'
      },
      {
        title: '次数',
        dataIndex: 'dinnerCount',
        key: 'dinnerCount',
        align: 'center'
      }
    ]
  },
  {
    title: '总金额',
    dataIndex: 'totalMoney',
    key: 'totalMoney',
    align: 'center'
  },
  {
    title: '总次数',
    dataIndex: 'totalCount',
    key: 'totalCount',
    align: 'center'
  }
];

export default {
  data() {
    return {
      selectDepartment: '',
      departmentList: [],
      tableData: [],
      tableColumns,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page;
          this.pagination.pageSize = pageSize;
          this._GetConsumeReportByDate();
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this._GetConsumeReportByDate();
        }
      },
      tableLoading: false,
      // 检索数据
      dateTimeRange: [getDateTimeRange(), moment()],
      // 选择
      selectedRowKeys: [],
      cardType: '',
      consumeType: '',
      cardTypeList: []
    };
  },
  methods: {
    // monment
    moment,
    _getCardTypeList() {
      GetCardTypeList().then(res => {
        if (res.data.state === 1) {
          this.cardTypeList = res.data.attribute
        }
      })
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.key === '合计',
          key: record.key
        }
      }
    },
    // 选择
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    // 日期选择器
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day');
    },
    onChangeDatePicker(date, dateString) {
      this.dateTimeRange = date;
    },
    changeCardType(value) {
      this.cardType = value;
    },
    changeConsumeType(value) {
      this.consumeType = value;
    },
    // 选择部门
    handleDepartment(value) {
      this.selectDepartment = value
    },
    search() {
      this.pagination.current = 1;
      this._GetConsumeReportByDate();
    },
    //   导出报表
    download() {
      let that = this;
      that.$confirm({
        title: '您确定要下载日消费记录报表吗？',
        content: '',
        onOk() {
          DownloadConsumeReportByDateExcel({
            startTime: that.dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss'),
            endTime: that.dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss'),
            dates: that.selectedRowKeys.join(','),
            consumeType: that.consumeType,
            cardTypeId: that.cardType,
            departmentId: that.selectDepartment
          }).then(
            res => {
              if (!res.data) {
                return;
              }
              let url = window.URL.createObjectURL(new Blob([res.data]));
              let link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', '日消费记录(' + that.dateTimeRange[0].format('YYYY-MM-DD') + '~' + that.dateTimeRange[1].format('YYYY-MM-DD') + ').xlsx');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          );
        }
      });
    },
    // 获取数据
    _GetConsumeReportByDate() {
      this.tableLoading = true;
      GetConsumeReportByDate({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize - 1,
        startTime: this.dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss'),
        consumeType: this.consumeType,
        cardTypeId: this.cardType,
        departmentId: this.selectDepartment
      }).then(res => {
        const resault = res.data.attribute;
        this.tableLoading = false;
        this.tableData = [];
        this.pagination.total = resault.pageCount;
        resault.rows.forEach((item, index) => {
          this.tableData.push({
            key: item.date.split('T')[0],
            date: item.date.split('T')[0],
            breakfastMoney: '￥' + item.breakfast,
            breakfastCount: item.breakfastCount,
            lunchMoney: '￥' + item.lunch + (item.lunch ? `(${item.lunch1}+${item.lunch2})` : ''),
            lunchCount: item.lunchCount + (item.lunchCount ? `(${item.lunchCount1}+${item.lunchCount2})` : ''),
            dinnerMoney: '￥' + item.dinner,
            dinnerCount: item.dinnerCount,
            totalMoney: '￥' + (item.breakfast * 100 + item.lunch * 100 + item.dinner * 100) / 100,
            totalCount: item.breakfastCount + item.lunchCount + item.dinnerCount
          });
        });
        this.tableData.push({
          key: '合计',
          date: '合计',
          breakfastMoney: '￥' + resault.total.breakfast,
          breakfastCount: resault.total.breakfastCount,
          lunchMoney: '￥' + resault.total.lunch + `(${resault.total.lunch1}+${resault.total.lunch2})`,
          lunchCount: resault.total.lunchCount + `(${resault.total.lunchCount1}+${resault.total.lunchCount2})`,
          dinnerMoney: '￥' + resault.total.dinner,
          dinnerCount: resault.total.dinnerCount,
          totalMoney: '￥' + resault.total.totalConsume,
          totalCount: resault.total.totalConsumeCount
        });
      },
        res => {
          this.tableLoading = false;
        });
    },
    // 获取部门下拉
    _GetDepartmentDropdownList() {
      GetDepartmentDropdownList().then(res => {
        this.departmentList = res.data.attribute
      })
    }
  },
  created() {
    this._getCardTypeList()
    this._GetConsumeReportByDate();
  },
  mounted() {
    this._GetDepartmentDropdownList()
  }
};
</script>

<style lang="less" scoped></style>

<style lang="less">
// 覆盖antd样式
.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #fafafa !important;
}

.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}
</style>
